// extracted by mini-css-extract-plugin
export var completionBody = "_f1-2";
export var completionCard = "_f1-0";
export var completionFooter = "_f1-3";
export var completionTitle = "_f1-1";